import { render } from "./Detail.vue?vue&type=template&id=41afe327"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
script.render = render

export default script